import { HTTP } from "@/helpers/http-common"

const url = "/api/usuario"

const get = (data) => new Promise((resolve, reject) => {
  const { username } = data;
  HTTP.get(`${url}/${username}`
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const list = (data) => new Promise((resolve, reject) => {
  HTTP.post(`${url}/list`, data
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const save = (data) => new Promise((resolve, reject) => {
  HTTP.post(url, data
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const update = (data) => new Promise((resolve, reject) => {
  HTTP.put(url, data
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const disable = (data) => new Promise((resolve, reject) => {
  const { username } = data;
  HTTP.delete(url, { params: { username } }).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error.response);
  });
});

const getPerfiles = data => new Promise((resolve, reject) => {
  const { username } = data;
  HTTP.get(`/api/usuariosPerfiles/${username}`
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const addPerfil = usuario => new Promise((resolve, reject) => {
  const { groupId, username } = usuario;
  HTTP.post("/api/usuariosPerfiles", { groupId: { clave: groupId }, username }
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const removePerfil = usuario => new Promise((resolve, reject) => {
  const { groupId, username } = usuario;
  HTTP.delete("/api/usuariosPerfiles", { params: { groupId, username } }
  ).then((response) => {
    resolve(response)
  })
    .catch((error) => {
      reject(error)
    });
});


const resetPassword = (username) => new Promise((resolve, reject) => {
  HTTP.get(`${url}/resetPassword/${username}`
  ).then(response => {
    console.log(response)
    resolve(response);
  }).catch(error => {
    reject(error.response);
  });
});

const updateStatus = (usuario) => new Promise((resolve, reject) => {
  const { username, enabled } = usuario;
  HTTP.put(`${url}/${username}/${enabled}`
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error.response);
  });
});

// Export methods
export default {
  get
  , list
  , save
  , update
  , disable
  , getPerfiles
  , addPerfil
  , removePerfil
  , resetPassword
  , updateStatus
}



// WEBPACK FOOTER //
// ./src/services/seguridad/usuario/index.js